import React from 'react';

const TestimonialServicesSection = () => {
  return (
    <div className="flex flex-col md:flex-row bg-white overflow-hidden">
      {/* Left side - Image */}
      <div className="md:w-1/2">
        <img 
          src="/DSC00065.jpg" 
          alt="Client in outdoor setting"
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Right side - Testimonial */}
      <div className="md:w-1/2 bg-[#336fb8] p-8 flex flex-col justify-center">
        <h2 className="text-white text-4xl font-bold mb-8">
          What sort of activities can we do?
        </h2>
        
        <blockquote className="text-white text-lg mb-6">
        Assistance with Social and Community Participation covers a wide range of activities. This is a great opportunity as you get a lot of freedom over your supports. Here are just some ideas for what's possible:
        </blockquote>
        
      </div>
    </div>
  );
};

export default TestimonialServicesSection;